import React from 'react';
import Spinner from 'components/kea/placeholders/Spinner';

const CircularProgress = ({ className, size = 50, r = 15 }) => (
  <div className={`loader ${className}`}>
    <Spinner size={size} r={r}/>
  </div>
);
export default CircularProgress;
